import React from 'react';
import LocationLandingPage from './LocationLandingPage';
import { Link } from 'react-router-dom';

const InteriorDesignNairobi = () => (
  <LocationLandingPage
    title="Interior Design Services in Nairobi | Residential & Commercial"
    description="Techie Interiors offers complete interior design services in Nairobi for homes, offices, and commercial spaces, with custom planning, fit-outs, and premium finishes."
    path="/interior-design-nairobi"
    h1="Interior Design Services in Nairobi"
    intro="We deliver modern residential and commercial interior design solutions across Nairobi, from concept planning to installation and final finishing."
    serviceType="Interior design services"
    highlights={[
      <>
        <Link to="/project">Residential interiors</Link> for apartments and family homes
      </>,
      <>
        <Link to="/project">Commercial interiors</Link> for offices, retail, and hospitality spaces
      </>,
      <>
        <Link to="/kitchen-wardrobe-fitting">Custom cabinetry</Link>, <Link to="/tv-gypsum-wall">wall panels</Link>,{' '}
        <Link to="/gypsum-ceiling">gypsum ceilings</Link>, and lighting integration
      </>,
      'End-to-end project execution with transparent timelines and budgeting',
    ]}
    faqs={[
      {
        question: 'Do you handle both design and installation in Nairobi?',
        answer: 'Yes. Our team manages design planning, materials, and installation to deliver a complete interior solution.',
      },
      {
        question: 'Can you work on occupied homes or offices?',
        answer: 'Yes. We phase work carefully to reduce disruption while maintaining quality and safety standards.',
      },
    ]}
  />
);

export default InteriorDesignNairobi;
